// Notification
export const NOTIFICATION_CLEAN = "NOTIFICATION_CLEAN"
export const NOTIFICATION_SHOW = "NOTIFICATION_SHOW"

// Auth
export const LOGOUT = "LOGOUT"
